import * as angular from "angular";
import template from "./user-requests.html";
import "./user-requests.less";

import { NOMENCLATURE } from "../../../constants";
import {
	FORMS_PROCESS_REQUEST, 
	FORMS_REJECT_REQUEST 
} from "../../../routes";
import {
	forEach,
	remove,
	isPlainObject
} from "lodash";
import moment from "moment-timezone";
import { isStringNullishOrEmpty } from "../../../services/string-service";
import pupa from "pupa";

export function controller(
	appState,
	loadingService,
	api,
	toastr,
	$uibModal,
	$logger
) {
	const ctrl = this;

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onInit = () => {
		ctrl.form = appState.forms.selected;
		ctrl.jsonFormSchema = ctrl.form?.Onboarding?.Requests?.Form;
		ctrl.requestFormatString = ctrl.form?.Onboarding?.Requests?.Summary;

		ctrl.entityNomenclature = ctrl.form.nomenclature[NOMENCLATURE.PrimaryEntity];
		ctrl.userPermissions = appState.permissions.Administration.User;

		forEach(ctrl.openRequests, r => {
			r.dobString = !!r.DateOfBirth ? moment(r.DateOfBirth).format("MM-DD-YYYY") : undefined;
			if(r.Data !== undefined && !isStringNullishOrEmpty(ctrl.requestFormatString)) {
				r.summaryDisplay = pupa(ctrl.requestFormatString, r.Data);
			}
		});
	};

	ctrl.hasRequestData = (request) => {
		return isPlainObject(request?.Data) && Object.keys(request.Data).length > 0;
	};

	ctrl.getEntityDisplay = (entity) => {
		if(!entity) {
			return "--";
		}

		const classificationIndex = entity.indexOf(" [");
		const identifierIndex = entity.indexOf(";[");
		let cutIndex = -1;

		if(classificationIndex >= 0 && identifierIndex >= 0) {
			cutIndex = Math.min(classificationIndex, identifierIndex);
		}
		else {
			cutIndex = Math.max(classificationIndex, identifierIndex);
		}

		if(cutIndex < 0) {
			return entity;
		}

		return entity.slice(0, cutIndex).trim();
	};

	ctrl.getEntityMetadataPreview = (entity) => {
		if(!entity) {
			return "";
		}

		const primary = ctrl.getEntityDisplay(entity);
		const metadata = entity.slice(primary.length).trim();

		return metadata;
	};

	ctrl.getEntityMetadataTokens = (entity) => {
		const metadata = ctrl.getEntityMetadataPreview(entity);
		if(!metadata) {
			return [];
		}

		const bracketTokens = metadata.match(/\[[^\]]+\]/g);
		if(!bracketTokens || !bracketTokens.length) {
			return [metadata];
		}

		return bracketTokens
			.map(token => token.slice(1, -1).trim())
			.filter(token => token.length > 0 && !token.match(/^[A-Za-z]+:\s*$/));
	};

	ctrl.view = (request) => {
		const showEntityAssignment = canShowEntityAssignment();
		const schemaFormOptions = {
			tv4Validation: false
		};

		$uibModal.open({
			size: "lg",
			backdrop: "static",
			component: "form-request-modal",
			resolve: {
				title: () => "Pending Request",
				schema: () => ctrl.jsonFormSchema,
				options: () => schemaFormOptions,
				model: () => request.Data,
				user: () => ctrl.user,
				showEntityAssignment: () => showEntityAssignment,
				process: () => () => ctrl.process(request),
				reject: () => () => ctrl.reject(request)
			}
		});
	};

	ctrl.process = async(request) => {
		const payload = buildRequestPayload(request, "PROCESSED");
		const route = FORMS_PROCESS_REQUEST(ctrl.form.Id, ctrl.user.Id, payload.Id);

		return submitRequestUpdate({
			request,
			route,
			payload,
			successMessage: "User form request has been marked as processed.",
			errorMessage: "There was an error processing your request"
		});
	};

	ctrl.reject = async(request) => {
		const modalInstance = $uibModal.open({
			size: "smmd",
			backdrop: "static",
			component: "rejection-reason-modal"
		});

		let reason;

		try {
			reason = await modalInstance.result;
		}
		catch(error) {
			toastr.info("Request rejection was cancelled.");
			
			return false;
		}

		const payload = buildRequestPayload(request, "REJECTED");

		if(reason) {
			payload.Comment = reason;
		}

		const route = FORMS_REJECT_REQUEST(ctrl.form.Id, ctrl.user.Id, payload.Id);

		return submitRequestUpdate({
			request,
			route,
			payload,
			successMessage: "User form request has been marked as rejected.",
			errorMessage: "There was an error processing your request"
		});
	};

	function canShowEntityAssignment() {
		// return !!ctrl.user && !ctrl.userPermissions?.IsDisabled && ctrl.userPermissions?.Actions?.CanPermit;
		return false;
	}

	function buildRequestPayload(request, status) {
		return {
			...request,
			IsProcessed: true,
			Status: status
		};
	}

	async function submitRequestUpdate({
		request,
		route,
		payload,
		successMessage,
		errorMessage
	}) {
		try {
			await loadingService.watch(api.put(route, payload));

			toastr.success(successMessage);
			markRequestResolved(request, payload.Id);

			return true;
		}
		catch(error) {
			toastr.error(errorMessage);

			return false;
		}
	}

	function markRequestResolved(request, requestId) {
		request.IsProcessed = true;
		remove(ctrl.openRequests, r => r.Id === requestId);
	}
}

export default angular.module("vesl.components.user-requests", [])
	.component("userRequests", {
		controller,
		template,
		bindings: {
			user: "<",
			openRequests: "="
		}
	}).name;
